// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AuditOutlinedSvg from "@ant-design/icons-svg/es/asn/AuditOutlined";
import AntdIcon from '../components/AntdIcon';

var AuditOutlined = function AuditOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AuditOutlinedSvg
  }));
};

AuditOutlined.displayName = 'AuditOutlined';
export default React.forwardRef(AuditOutlined);